import {NewCampaignOne} from './new_campaign_one'
import {NewCampaignTwo} from './new_campaign_two'
import {NewCampaignThree} from './new_campaign_three'

export class NewCampaign extends HTMLElement {
  constructor(is_admin) {
    super();
    this._is_admin = is_admin;
  }

  async connectedCallback() {
    let domain_id = document.querySelector("#object_id").value
    let data = await fetch(`/admin/domains/${domain_id}/campaign_defaults`);
    let defaults = await data.json();
    
    let stepOne = new NewCampaignOne(this._is_admin, domain_id, defaults);
    let stepTwo = new NewCampaignTwo;
    let stepThree = new NewCampaignThree;
    this.innerHTML = `
    <div class="row">
      
      <div class="col-lg-7 col-md-12 col-lg-offset-2" id="new-campaign-main">
        <h3><span id="campaign-back"></span> Campaign Wizard</h3>
        <p>Build your campaign</p>
      </div>
      
    </div>`;
    this.querySelector('#new-campaign-main').appendChild(stepOne);
    this.querySelector('#new-campaign-main').appendChild(stepTwo);
    this.querySelector('#new-campaign-main').appendChild(stepThree);

    this.querySelector('#campaign-count').onchange = (e) => {
      this.querySelector("local-numbers").setAttribute("numbers-required", e.target.value)
    }

    this.querySelector('#campaign-back').addEventListener('click', function() {
      this.cancelNew();
    }.bind(this))

    this.querySelectorAll('.step-cancel').forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        this.cancelNew();
      }.bind(this))
    })

    this.querySelector('#step-3-finish').addEventListener('click', function(e) {
      e.preventDefault()
      this.querySelector('#step-3-finish').setAttribute("disabled", true)
      this.saveCampaign()
    }.bind(this))
  }
  cancelNew() {
    this.remove();
    document.querySelector('#campaign_list_items').style.display = 'initial';
  }

  async saveCampaign() {
    if(this.validate()) {
      let domain_id = document.querySelector("#object_id").value
      let data = {};
      data.domain_id = domain_id;
      data.campaign_name = this.querySelector("#campaign-name").value;
      data.callshield = this.querySelector("#call-shield-switch").checked;
      data.enable_call_recording = this.querySelector("#call-rec-switch").checked;

      data.speech_transcription = this._is_admin && this.querySelector("#call-rec-switch").checked ? (this.querySelector('#speech-transcription-enabled-switch').checked ? 1 : 0) : 0;
      if (data.speech_transcription) {
        data.redaction = this.querySelector('#redaction-enabled-switch').checked ? 1 : 0;
      } else {
        // if transcription is off, force redaction to be off too.
        data.redaction = 0;
      }


      if(this.querySelector('#texting-switch') != null) {
        data.did_texting_enabled = this.querySelector('#texting-switch').checked ? 1 : 0;
        if(data.did_texting_enabled == 1) {
          data.texting_team_id = this.querySelector("select[name='teams']").value;
          data.message_tree_id = this.querySelector("#chat_message_tree_id").value;
        }
      }
      
      data.call_processing_map = this.querySelector('#lead-score-switch').checked ? 1 : 0;
      
      data.phone_number_type = this.querySelector("#campaign_wizard_toll_free").checked ? 0 : 1;
      data.target_id = this.querySelector(".call_treatments_id").value;
      data.campaign_tag_data = this.querySelector("tag-input").getData();
      
      if(data.target_id === "") {
        data.target_id = null;
      }

      // Set ring to number if not empty
      if(this.querySelector("#new-camp-rtn").value != "") {
        let ring_to = this.querySelector('#new-camp-rtn').value.split("@");
        if(ring_to.length == 1) {
          data.ring_to_number = ring_to[0].replace(/\D/g,'');
          data.ring_to_domain = null;
       } else {
          data.ring_to_number = ring_to[0].replace(/\D/g,'');
          data.ring_to_domain = ring_to[1]
       }
      }
      data.call_disclaimer = this.querySelector("#call-rec-switch").checked ? this.querySelector('input[name="disclaimer-lang"]:checked').value : 0;

      data.actions = [];
      let consumer_greeting = this.querySelector('#consumer-greeting-select').value;
      if(consumer_greeting != "null") {
        let action = {
          action_timing: 1,
          action_type: "AUDIO",
          action_parameters: [{
            parameter_name: "audio_id",
            parameter_value: consumer_greeting
          }, 
          {
            parameter_name: "channel",
            parameter_value: NewCampaign.CHANNEL_AUDIO_CONSUMER
          }]
        }
        data.actions.push(action);
      }
      
      let sales_rep_whisper = this.querySelector('#sales-rep-select').value;
      if(sales_rep_whisper != "null") {
        let action = {
          action_timing: 3,
          action_type: "AUDIO",
          action_parameters: [{
            parameter_name: "audio_id",
            parameter_value: sales_rep_whisper
          }, 
          {
            parameter_name: "channel",
            parameter_value: NewCampaign.CHANNEL_AUDIO_TARGET
          }]
        }
        data.actions.push(action);
      }

      if(this.querySelector("#representive-code-switch").checked) {
        data.actions.push({
          action_timing: 6,
          action_type: "REP_CODE"
        })
      }

      this.querySelectorAll("webhook-form").forEach((webhook_form) => {
        let webhook_value = webhook_form.getValue();
        if(webhook_value != null) {
          data.actions.push(webhook_value);  
        }
      });
      data.voicemail_enabled = this.querySelector("#voicemail-switch").checked ? 1 : 0;
      if(this.querySelector('#voicemail-switch').checked) {
        data.voicemail_rollover_time = this.querySelector("#voicemail_rings").value;
        data.voicemail_audio_id = this.querySelector("#voicemail-greeting-select").value == "null" ? null : this.querySelector("#voicemail-greeting-select").value;
      }

      let quanityToCreate = this.querySelector("#campaign-count").value;
      if(!this.querySelector("#campaign_wizard_toll_free").checked) {
        quanityToCreate = 0
        this.querySelector("local-numbers").value.map(function(npanxx) {quanityToCreate+=npanxx.qtyRequired})
      }

      // Check if form is valid;
      if(!this.querySelector("#campaign_wizard_toll_free").checked && !this.querySelector("local-numbers").isValid()) {
        return;
      }
      if(this.querySelector("#campaign_wizard_toll_free").checked && !this.querySelector("toll-free-numbers").isValid()) {
        return;
      }

      let post = {
        local_numbers: !this.querySelector(".campaign_toll_free").checked,
        npanxx: this.querySelector("local-numbers").value,
        npa_toll_free: this.querySelector("toll-free-numbers").value,
        campaigns: data,
        qty: quanityToCreate
      }

      try {
        let res = await fetch('/admin/campaigns/create', {
          headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                    'Content-type': 'application/json'},
          method: 'POST',
          body: JSON.stringify(post)
        })
        if (!res.ok) {// or check for response.status
          this.querySelector('#step-3-finish').removeAttribute("disabled")
          throw new Error(res.statusText);
        }
        
        let response = await res.json();
        if(response.success) {
          Common.notify('New campaigns created', 'success');
          CampaignsList.reloadData();
          TreatmentsManager.reloadTreatments();
          this.cancelNew();
        } else {
          this.querySelector('#step-3-finish').removeAttribute("disabled")
          Common.notify(response.message != null ? response.message : 'Failed to save campaign.', 'error');
        }
      } catch (err) {
        Common.notify('Sorry an error occured unable to create campaigns', 'error');
      }
    }
  }

  validate() {
    this.querySelector('#step-3-finish').removeAttribute("disabled")
    let is_valid = true;

    if(!this.querySelector('new-campaign-one').validateStep()) {
      is_valid = false;
    }
    if(!this.querySelector('new-campaign-two').validateStep()) {
      is_valid = false;
    }
    this.querySelector('new-campaign-three').querySelector('.errors').innerHTML = "";
    if(this.querySelector('#texting-switch') != null && this.querySelector('#texting-switch').checked == true && this.querySelector('#campaign_wizard_toll_free').checked == true) {
      this.querySelector('new-campaign-three').querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Texting cannot be enabled on toll free numbers.
                                                </div>`;
      is_valid = false;
    }

    return is_valid;
  }

  // retrieveWebhooks() {
  //   let data_set = [];
  //   this.querySelectorAll("webhook-form").forEach((webhook_form) => {
  //     let webhook_value = webhook_form.getValue();
  //     if(webhook_value != null) {
  //       data_set.push(webhook_value);  
  //     }
  //   });
  //   return data_set;
  // }

}

NewCampaign.CHANNEL_AUDIO_CONSUMER = 0;
NewCampaign.CHANNEL_AUDIO_TARGET = 1;

customElements.define('new-campaign', NewCampaign)